import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a date (ISO string, timestamp, or Date) as a short human-readable
 * string, e.g. "Jul 8, 2026, 11:28 AM". Returns an empty string for
 * missing/invalid input so callers can render it directly.
 */
export function formatDate(
  value: string | number | Date | null | undefined
): string {
  if (!value) return ""
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return ""
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  })
}
